import api, { EnterpriseRcb } from "api";
import { AppForm, AppFormItemEnum, AppFormLayout, AppFormPageProps } from 'qcc';
import React from 'react';

export default class EnterpriseRcbEditForm extends React.PureComponent<AppFormPageProps> {
  refAppForm = React.createRef<AppForm>()
  state = {
    mode: this.props.mode || 1
  }
  // 保存
  save = async (formData?: EnterpriseRcb) => {
    return this.state.mode === 1 ? await api.posenterprisercb.create(formData) : await api.posenterprisercb.update(formData);
  }

  render() {
    let { formData, mode, id } = this.props;
    return (<AppFormLayout defaultButton mode={this.props.mode} >
      <AppFormLayout.Form>
        <AppForm ref={this.refAppForm} entity='pos_enterprise_rcb' loadingData={false} mode={mode} keyValue={id} formData={formData}
          save={this.save}
          afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
          <AppForm.Section labelWidth={120} >
            <AppForm.Item label='企业名称'
              field='openName'
              itemType={AppFormItemEnum.input} unRepeat scopeField='project_id' req />
            <AppForm.Item label='企业标识'
              field='openId'
              itemType={AppFormItemEnum.input} unRepeat scopeField='project_id' req />
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/pos/enterpriseRcb/EnterpriseRcbEditForm.tsx